import chatgptLogo from '@/assets/ai-logos/chatgpt.svg';
import claudeLogo from '@/assets/ai-logos/claude.svg';
import type { AiApp } from '@/services/mcpConnectionsService';

/** Zamino's remote MCP server — what external AI apps connect to. */
export const MCP_SERVER_URL = 'https://api.zamino.com/mcp';

/** One-click "add Zamino" deep link — prefills Claude's custom-connector modal. */
export const CLAUDE_CONNECT_URL =
  'https://claude.ai/customize/connectors?modal=add-custom-connector&connectorName=Zamino&connectorUrl=' +
  encodeURIComponent(MCP_SERVER_URL);

/** Opens ChatGPT's security settings with the Developer mode section expanded. */
export const CHATGPT_DEV_MODE_URL = 'https://chatgpt.com/plugins#settings/Security?section=developer-mode';

/**
 * Opens ChatGPT's new-connector dialog directly. ChatGPT has no documented
 * prefill params, so the name/URL still have to be pasted in by hand.
 */
export const CHATGPT_CREATE_CONNECTOR_URL =
  'https://chatgpt.com/plugins#settings/Connectors?create-connector=true&redirectAfter=%2Fplugins';

/** First message to send once connected — proves the link works and orients the model. */
export const CHATGPT_KICKOFF_PROMPT =
  'Use the Zamino app to show my connected data sources, then suggest five questions I can ask about my business.';

export const CLAUDE_CODE_ADD_COMMAND = `claude mcp add --transport http zamino ${MCP_SERVER_URL}`;

export interface AiAppMeta {
  label: string;
  /** Logo asset URL; null → fall back to a generic icon. */
  logo: string | null;
  /** Where "Open in …" goes once connected; null → no open affordance. */
  openUrl: string | null;
}

export const AI_APP_META: Record<AiApp, AiAppMeta> = {
  chatgpt: { label: 'ChatGPT', logo: chatgptLogo, openUrl: 'https://chatgpt.com' },
  claude: { label: 'Claude', logo: claudeLogo, openUrl: 'https://claude.ai' },
  claude_code: { label: 'Claude Code', logo: claudeLogo, openUrl: null },
  other: { label: 'External AI', logo: null, openUrl: null },
};

/** Stable display order for connected-app chips and picker tiles. */
export const AI_APP_ORDER: AiApp[] = ['chatgpt', 'claude', 'claude_code', 'other'];
